module.exports = __webpack_public_path__ + "img/area_1.df8335b9.jpg";